// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"SingleProductBrandRefresh_pageWrapper__FumLd"};